<template>
	<div class="cnt-list-services">
		<div class="well well-sm">
			<div class="row">
				<div class="col-xs-12">
					<span>Serviço</span>
					<div class="input-group">
						<input
							type="text"
							placeholder="Cód. / Titulo"
							:disabled="selStatus"
							@focusin="searchPanel = true"
							class="form-control"
							style="height: 32.5px"
							v-model="searchService"
						/>
						<span class="input-group-btn">
							<button
								class="btn btn-default"
								v-if="!selStatus && !searchPanel"
								@click="searchPanel = true"
							>
								<i class="fa fa-search"></i>
							</button>
							<button
								class="btn btn-danger"
								v-if="selStatus || searchPanel"
								@click="resetAddForm"
							>
								<i class="fa fa-close"></i>
							</button>
						</span>
					</div>
					<ul
						class="contOptionsService"
						:class="{ hide: !searchPanel, show: searchPanel }"
					>
						<li
							v-for="(services, index) in filterServices"
							:key="index"
							@click="selectObjFx(services)"
						>
							<i class="fa fa-link"></i> {{ services.servico }}

							<b v-if="services.cat == 'web'">APP</b>
							<b v-if="services.cat == 'offshore'">Offshore</b>
							<b v-if="services.cat == 'internos'">Interno</b>
							<b v-if="services.cat == 'sms'">SMS</b>

							<b class="pull-right">
								R$ {{ parseFloat(services.valor).toFixed(2) }}
							</b>
						</li>
					</ul>
				</div>
				<div class="col-xs-3">
					<span>Desconto</span>
					<div class="input-group">
						<div class="input-group-addon">R$</div>
						<input
							type="text"
							:disabled="!selStatus"
							v-model="selectObj.desconto"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-xs-3">
					<span>Acréscimo</span>
					<div class="input-group">
						<div class="input-group-addon">R$</div>
						<input
							type="text"
							:disabled="!selStatus"
							v-model="selectObj.acrescimo"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-xs-3">
					<span>Valor</span>
					<div class="input-group">
						<div class="input-group-addon">R$</div>
						<input
							type="text"
							disabled
							:value="parseFloat(selectObj.valor || 0).toFixed(2)"
							class="form-control"
						/>
					</div>
				</div>
				<div class="col-xs-3">
					<br />
					<button
						:disabled="!selStatus"
						class="btn btn-success btn-block"
						@click="addService"
					>
						<i class="fa fa-plus"></i>
						Adicionar
					</button>
				</div>
			</div>
		</div>
		<b>Lista de serviços [{{ data.list_services.length }}]</b>
		<div class="well well-sm well-custon">
			<table class="table table-bordered table-striped">
				<thead>
					<tr>
						<th>
							<input type="checkbox" v-model="check" />
						</th>
						<th>
							<input type="checkbox" v-model="comissionado" />
						</th>
						<th colspan="2">Serviço</th>
						<th>Qnt.</th>
						<th>Val Unit</th>
						<th>Desc.</th>
						<th colspan="2">Sub total</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(serv, id) in data.list_services">
						<td>
							<input
								type="checkbox"
								@click="forceCheck(id, serv)"
								v-model="serv.check"
							/>
						</td>
						<td>
							<input
								type="checkbox"
								v-model="serv.comissionado"
							/>
						</td>

						<td>
							<span
								v-if="serv.cat == 'web'"
								class="label label-warning"
							>
								APP
							</span>
							<span
								v-if="serv.cat == 'offshore'"
								class="label label-info"
							>
								Offshore
							</span>
							<span
								v-if="serv.cat == 'internos'"
								class="label label-default"
							>
								Interno
							</span>
							<span
								v-if="serv.cat == 'sms'"
								class="label label-primary"
							>
								SMS
							</span>
						</td>
						<td>
							<small>{{ serv.servico }}</small>
						</td>

						<td>
							<input
								type="number"
								class="form-intable"
								v-model="serv.qnt"
							/>
						</td>
						<td>R$ {{ parseFloat(serv.valor).toFixed(2) }}</td>
						<td>
							R$
							<input
								type="number"
								class="form-intable"
								v-model="serv.desconto"
							/>
						</td>
						<th class="warning">
							R$ {{ parseFloat(getSbTtItem(serv)).toFixed(2) }}
						</th>

						<td>
							<span class="pull-right">
								<button
									class="btn btn-danger btn-xs"
									@click="removeItem(id)"
								>
									<i class="fa fa-trash-o"></i>
								</button>
							</span>
						</td>
					</tr>
					<tr v-if="data.list_services.length == 0">
						<td colspan="9">Nenhum serviço vinculado!</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row">
			<div class="col-sm-3 col-xs-12">
				<span>Acréscimo</span>
				<div class="input-group">
					<span class="input-group-addon"> R$ </span>
					<input
						v-model="data.acrescimo"
						type="text"
						class="form-control"
					/>
				</div>
			</div>
			<div class="col-sm-3 col-xs-12">
				<span>Desconto</span>
				<div class="input-group">
					<span class="input-group-addon"> R$ </span>
					<input
						v-model="data.desconto"
						type="text"
						class="form-control"
					/>
				</div>
			</div>
			<div class="col-sm-3 col-xs-12">
				<span>Sub. Total</span>
				<div class="input-group">
					<span class="input-group-addon"> R$ </span>
					<input
						type="text"
						:value="parseFloat(getSubTotal).toFixed(2)"
						disabled
						class="form-control"
					/>
				</div>
			</div>
			<div class="col-sm-3 col-xs-12">
				<b>Total</b>
				<div class="input-group">
					<span class="input-group-addon">R$</span>
					<input
						type="text"
						:value="parseFloat(getTotal).toFixed(2)"
						disabled
						class="form-control"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	export default {
		name: 'ListServices',
		props: ['dIn', 'assets'],
		data() {
			return {
				searchPanel: false,
				searchService: '',
				selStatus: false,
				selectObj: {},

				check: false,
				comissionado: false,
			};
		},
		watch: {
			check: function (val) {
				this.update_all_status('check', val);
			},
			comissionado: function (val) {
				this.update_all_status('comissionado', val);
			},
		},
		computed: {
			filterServices() {
				if (this.assets.servicos !== undefined) {
					return this.assets.servicos.filter((it) => {
						if (
							it.cod == this.searchService ||
							it.servico
								.toLowerCase()
								.indexOf(this.searchService.toLowerCase()) != -1
						)
							return it;
					});
				} else {
					return [];
				}
			},
			data() {
				return this.dIn;
			},
			getSubTotal() {
				let sbTotal = 0;
				this.data.list_services.forEach((item) => {
					// console.log(item)
					if (item.check == true) {
						let calc = parseFloat(item.valor) * parseInt(item.qnt);
						sbTotal +=
							calc -
							parseFloat(item.desconto) +
							parseFloat(item.acrescimo);
					}
				});
				return sbTotal;
			},
			getTotal() {
				return (
					parseFloat(this.data.acrescimo) +
					parseFloat(this.getSubTotal) -
					parseFloat(this.data.desconto)
				);
			},
		},
		methods: {
			update_all_status(who, value) {
				this.data.list_services.forEach((item) => {
					if (item[who] != undefined) {
						item[who] = value;
					}
				});
			},
			getSbTtItem(item) {
				let calc = parseFloat(item.valor) * parseInt(item.qnt);
				return (
					calc -
					parseFloat(item.desconto) +
					parseFloat(item.acrescimo)
				);
			},
			forceCheck(id, serv) {
				this.$set(this.data.list_services, id, serv);
			},
			selectObjFx(data) {
				let newObj = clone(data);
				newObj.desconto = 0;
				newObj.acrescimo = 0;
				newObj.ciclos = 1;
				this.searchService = newObj.servico;
				this.selectObj = newObj;
				this.selStatus = true;
				this.searchPanel = false;
			},
			removeItem(id) {
				this.data.list_services.splice(id, 1);
			},
			addService() {
				if (this.selectObj !== {}) {
					let exist = this.data.list_services.filter((data) => {
						if (data.cod == this.selectObj.cod) return data;
					});
					if (exist[0] === undefined) {
						this.selectObj.qnt = 1;
						this.selectObj.check = true;
						this.selectObj.comissionado = false;
						this.selectObj.valor =
							parseFloat(this.selectObj.valor) -
							parseFloat(this.selectObj.desconto) +
							parseFloat(this.selectObj.acrescimo);
						this.selectObj.desconto = this.selectObj.acrescimo = 0;
						this.data.list_services.push(this.selectObj);
					} else {
						exist[0].qnt++;
					}
					this.resetAddForm();
				} else {
					this.hasErro = true;
				}
			},
			resetAddForm() {
				this.searchService = '';
				this.selectObj = {};
				this.selStatus = false;
				this.searchPanel = false;
			},
		},
	};
</script>
<style scoped>
	.form-control {
		height: 33px;
	}
	.contOptionsService {
		position: absolute;
		z-index: 100;
		background: #fff;
		width: calc(100% - 30px);
		padding: 0;
		border: 1px solid #cecece;
		border-radius: 3px;
		box-shadow: 1px 1px 1px #cecece;
		max-height: 300px;
		overflow-y: scroll;
		overflow-x: hidden;
	}
	.contOptionsService li {
		list-style: none;
		padding: 5px 10px;
		cursor: pointer;
	}
	.contOptionsService li:nth-child(2n) {
		background: rgba(206, 206, 206, 0.18);
	}
	.contOptionsService li:hover {
		background: rgba(43, 43, 43, 0.24);
		/* color: #ffffff; */
	}
	.form-intable {
		width: 45px;
		text-align: center;
		border: none;
		background: none;
		display: inline;
	}
	.cntInpQnt {
		display: block;
		margin: 0px auto;
		width: 52px;
	}
	.form-intable:focus {
		outline: none;
	}
	.well-custon {
		height: 337px;
		background: #fff;
		padding: 0;
		overflow-y: auto;
	}

	.well-custon::-webkit-scrollbar-track,
	.contOptionsService::-webkit-scrollbar-track {
		background-color: #f4f4f4;
	}
	.well-custon::-webkit-scrollbar,
	.contOptionsService::-webkit-scrollbar {
		width: 3px;
		background: #f4f4f4;
	}
	.well-custon::-webkit-scrollbar-thumb,
	.contOptionsService::-webkit-scrollbar-thumb {
		background: #dad7d7;
	}
</style>



// WEBPACK FOOTER //
// src/components/proposals/components/components/services.vue